export default __webpack_public_path__ + "static/media/Metropolis-Bold.4fb24623.woff";